<template>
    <!--预约看房-->
    <div class="appoint">
        <div class="appo">
            <div class="appointment">
                <div class="left">
                    <div class="content">
                        <div>一键预约，房产交易，品质服务</div>
                        <span>真实房源</span>
                        <span>一键预约</span>
                    </div>
                </div>
                <div class="right">
                    <div class="inputBox">
                        <input type="text" v-model="lookhouse.name" placeholder="请输入您的姓名">
                        <span>{{ mesName }}</span>
                    </div>
                    <div class="inputBox">
                        <input type="text" v-model="lookhouse.phone" placeholder="请输入您的手机号码">
                        <span>{{ mesPhone }}</span>
                    </div>
                    <span class="time">预约时间</span>
                    <div class="date">
                        <div class="select">
                            <select v-model="formData.startyear">
                                <option :value="item" v-for="item in year">{{ item }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                        <div class="select" @change="getDay()">
                            <select v-model="formData.startmonth">
                                <option :value="item" v-for="item in month">{{ item}}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                        <div class="select">
                            <select v-model="formData.startday">
                                <option :value="item" v-for="item in day">{{ item}}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                    <div class="inputBox">
                        <input type="text" v-model="lookhouse.time_str" placeholder="请输入时间段，如下午3点">
                        <span>{{ mesTime }}</span>
                    </div>

                    <div class="auto_assign">系统自动分配经纪人</div>
                    <p>提交预约后，请保持手机畅通，经纪人会在30-60分钟联系您</p>
                    <button class='submit' @click="submitAppoint" style="cursor: pointer">提交预约</button>
                </div>
            </div>
            <div class="close">
                <i class="iconfont" @click="closeAppoint()" style="cursor: pointer" title="关闭">&#xe617;</i>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	export default {
		props: {
			propHouse: {
				obj: Object
			}
		},
		data() {
			return {
				lookhouse: {
					house_id: '',
					url: '',
					time: '',
					name: '',
					phone: '',
					time_str: '',
				},
				//获取年月日
				formData: {
					startyear: '',
					startmonth: '',
					startday: '',
				},
				year: [],
				month: [],
				day: [],
				mesName: '',
				mesPhone: '',
				mesTime: '',
				isShow: true
			}
		},
		components: {},
		mounted() {
			this.init()

		},
		created() {
		},
		methods: {
			submitAppoint() {
				// console.log(window.location.href)
				let regTel = /^\d{11}$/g;
				this.lookhouse.house_id = this.propHouse.house_id;
				this.lookhouse.url = window.location.href;
				this.lookhouse.time = this.formData.startyear + '-' + this.formData.startmonth + '-' + this.formData.startday;
				if (this.lookhouse.name === '') {
					this.mesName = '请输入姓名'
				} else if (this.lookhouse.phone === '') {
					this.mesPhone = '请输入手机号'
				} else if (!regTel.test(this.lookhouse.phone)) {
					this.mesPhone = ('请输入11位手机号')
				} else if (this.lookhouse.time_str === '') {
					this.mesTime = '请输入具体时间'
				} else {
					this.mesName = '';
					this.mesPhone = '';
					this.mesTime = '';
					this.$api.LookHouse(
						this.lookhouse
					).then(res => {
						console.log(res)
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.$emit('headCallBack', false)
					}).catch(res => {
						console.log(res)
					})
				}
			},
			// 关闭预约看房
			closeAppoint() {
				this.$emit('headCallBack', false)
			},
			init() {
				this.getYear();
				this.getMonth();
				this.getDay();
			},
			getYear() {//获取年
				let date = new Date;
				let current_year = date.getFullYear();
				for (let i = 0; i < 100; i++) {
					let y = current_year + i;
					this.year.push(y);
				}
				this.formData.startyear = current_year
				// console.log(current_year)
			},
			getMonth() {//获取月
				let date = new Date;
				let current_month = date.getMonth();
				for (let i = 1; i < 13; i++) {
					this.month.push(i);
				}
				this.formData.startmonth = current_month + 1
				// console.log(current_month)
			},
			getDay() {//获取日
				let date = new Date;
				let current_day = date.getDate();
				let day = this.getDaysInMonth(this.formData.startyear, this.formData.startmonth)
				for (let i = 1; i <= day; i++) {
					this.day.push(i);
				}
				this.formData.startday = current_day
				// console.log(current_day)
			},
			getDaysInMonth(year, month) {//获取某个月的天数
				month = parseInt(month, 10);
				let d = new Date(year, month, 0);
				return d.getDate();
			},
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    /*预约看房*/
    .appoint {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.25);
        z-index: 5;
        .appo {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            .close {
                position: absolute;
                top: 14px;
                right: 14px;
                i {
                    font-size: 16px;
                    color: #666;
                }
            }
            .appointment {
                display: flex;
                justify-content: space-between;
                width: 782px;
                background: #fff;
                .left {
                    position: relative;
                    background: url("../assets/images/detail/img_tanchuang_img.png") no-repeat;
                    width: 318px;
                    height: 500px;
                    color: #fff;
                    text-align: center;
                    flex-shink: 0;
                    .content {
                        width: 100%;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        div {
                            font-size: 18px;
                            font-family: MicrosoftYaHei-Bold;
                            font-weight: bold;
                        }
                        span {
                            display: inline-block;
                            font-size: 16px;
                            margin: 20px 40px 40px 0;
                        }
                        span:last-child {
                            margin-right: 0;
                        }
                    }
                }
                .right {
                    flex: 1;
                    font-size: 14px;
                    padding: 40px;
                    .inputBox {
                        position: relative;
                        margin-bottom: 20px;
                        input {
                            width: 100%;
                            color: #666;
                            padding: 10px 0;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            border-bottom: 1px solid #E6E6E6;
                        }
                        span {
                            position: absolute;
                            top: 100%;
                            left: 0;
                            color: #FF5E5E;
                        }
                    }
                    .time {
                        display: block;
                        color: #666;
                        padding: 18px 0;
                    }
                    .date {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 30px;
                        .select {
                            position: relative;
                            width: 110px;
                            color: #333;
                            select {
                                width: 100%;
                                border: solid 1px #ccc;
                                appearance: none;
                                -moz-appearance: none;
                                -webkit-appearance: none;
                                padding: 0 24px 0 10px;
                                line-height: 32px;
                                border-radius: 4px;
                                outline: none;
                            }
                            i {
                                position: absolute;
                                top: 50%;
                                right: 10px;
                                transform: translateY(-50%);
                                font-size: 8px;
                            }
                            select::-ms-expand {
                                display: none;
                            }
                        }
                    }
                    .auto_assign {
                        width: 160px;
                        text-align: center;
                        color: #FFAE01;
                        padding: 7px 0;
                        border: 1px solid #FFAE01;
                    }
                    p {
                        color: #B3B3B3;
                        margin: 10px 0 30px;
                    }
                    button.submit {
                        position: absolute;
                        right: 152px;
                        bottom: 40px;
                        width: 160px;
                        display: block;
                        color: #fff;
                        background: #FFAE01;
                        padding: 8px 0;
                        margin: 0 auto;
                        border: none;
                    }
                }
            }
        }
    }
</style>